/******************************************************
 *                  Coherence List Ctrl
 ********************************************************/

"use strict";

angular.module("coherence")
	.controller("CoherenceListCtrl",
		["$scope", "$routeParams", "$location", "$log", "toastr", "Utils", "$uibModal", "CoherenceService", "type", "list",
		function ($scope, $routeParams, $location, $log, toastr, Utils, $uibModal, CoherenceService, type, list) {
			let modal;

			$scope.data = {
				type: type,
				list: list.data,
			};

			$scope.displayComment = (comment) => {
				$scope.data.currentDisplayedComment = comment;
				modal = Utils.openModal($uibModal, "commentItemModal.html", $scope, "lg");
			};

			$scope.goToDetail = (id) => {
				$location.path($location.$$path + "/detail/" + id);
			};
		}]
	)
;
